<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Editar Domínio <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-4">
                        <label><span class="required">*</span>Domínio</label>
                        <input type="text" class="form-control" v-model="domain.domain" disabled>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="tenant"><span class="required">*</span>Tenant</label>
                        <input type="text" class="form-control" v-model="domain.tenant_id" disabled>
                    </div>
                    <div class="form-group col-md-4">
                        <label for="tenant"><span class="required">*</span>Nome</label>
                        <input type="text" class="form-control" v-model="domain.tenant.company_name">
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/domains" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                domain: {
                    domain: '',
                    tenant_id: '',
                    tenant: {
                        company_name: ''
                    }
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'domains/saveCompanyName';

                let form  = new FormData();

                form.append('id', + self.$route.params.id);
                form.append('company_name', self.domain.tenant.company_name);

                self.$http.post(api, form)
                    .then((response) => {
                        self.$message('Sucesso', `Domínio editado com sucesso`, 'success');
                        this.$router.push('/domains');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getDomain(){
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'domains/' + id + '?with[]=tenant';

                self.$http.get(api)
                    .then((response) => {
                        self.domain = response.data.data[0];
                    })
                    .catch((error) => {
                       self.$message(null, 'Ocorreu um erro ao buscar as informações do Cargo', 'error');
                    });
            }
        },
        mounted: function(){
            this.getDomain();
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Domains/Edit.vue